/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';
import { AuthPostLogin } from './authentication-login.post';

export const AuthPostRegister = {
  id: 'authentication.register.post',
  tag: 'Authentication',
  summary: 'Register User',
  description: 'Register a new user.',
  method: 'post',
  route: () => `/authentication/register`,
  request: {
    body: {
      required: true,
      content: {
        'application/json': {
          schema: z.strictObject({
            firstName: ZodTypes.TrimmedString.min(1),
            lastName: ZodTypes.TrimmedString.min(1),
            middleName: ZodTypes.TrimmedString.optional(),
            language: ZodTypes.Language,
            email: ZodTypes.TrimmedString.min(1, 'string').email(),
            password: ZodTypes.Password,
            thumbnail: ZodTypes.ThumbnailFormat.optional(),
            isSuperuser: z.boolean().optional(),
          }),
        },
      },
    },
  },
  response: AuthPostLogin.response,
} as const satisfies Endpoint;
